module.exports = __webpack_public_path__ + "img/icon_clear.941a1eed.png";